import React, { useState } from "react";
//import Axios from "axios"
import "../css/Pricing.css";
import { useAuth } from './AuthContext';
import useSubscriptionDetails from '../hooks/useSubscriptionDetails';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import SidebarLayout from './SidebarLayout';
import tick_icon from '../assets/tick_icon.png'
import loader_blocks from '../assets/loader_blocks.gif'

const PricingPlans = () => {
  const { user } = useAuth();

  //const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  //const [loading, setLoading] = useState(true);
  //const [userId, setUserId] = useState('');
  const [isExpanded, setIsExpanded] = useState(false); // State to control sidebar

  const URL_MONTHLY = process.env.REACT_APP_PAYMENTLINK_MONTHLY;
  const URL_YEARLY = process.env.REACT_APP_PAYMENTLINK_YEARLY;

  const { subscriptionDetails, userId, loading, error } = useSubscriptionDetails(user);

  //console.log(URL_MONTHLY);

  

  // useEffect(() => {
  //   //console.log(user);
  //   const fetchSubscriptionDetails = async () => {
  //     if (user) {
  //       setUserId(user.uid)
  //       try {

  //         // Create a new FormData object
  //         const formData = new FormData();
  //         formData.append('request', 'getSubscriptionDetails');
  //         formData.append('userId', user.uid);
  //         formData.append('email', user.email);

  //         const URL = process.env.REACT_APP_BACKENDURL;

  //         // Send the POST request using Axios
  //         const response = await Axios.post(URL, formData, {
  //           headers: {
  //             'Content-Type': 'multipart/form-data', // Important for FormData
  //           },
  //           withCredentials: true, // Include credentials (cookies) if necessary
  //         });

  //         if (response.status === 200) {
  //           setSubscriptionDetails(response.data.data);
  //           //console.log(subscriptionDetails);
  //         }
  //       } catch (error) {
  //         console.error('Error fetching subscription details:', error);
  //       }
  //     }
  //     setLoading(false);
  //   };

  //   fetchSubscriptionDetails();
  // }, [user]);

  const handleSubscribedBtnClick = (planType, stripeUrl) => {
    if (planType) {
      if (stripeUrl) {
        localStorage.setItem("redirectAfterLogin", stripeUrl);
      }

      // Store a variable in local storage
      localStorage.setItem('planType', planType);
    }
  };

  if (loading) {
    return <div className="container pricing-card text-center py-5" style={{ color: '#EEEEF0' }}><p><img loading="lazy" src={loader_blocks} alt="vasi animated" className="animated-icon" /></p></div>;
  }

  return (
    <>
      {subscriptionDetails ? (
        <div className={`container pricing-card text-center py-5 ${isExpanded ? "expanded-search-mobile" : ""}`} style={{ color: '#EEEEF0', maxWidth: "800px" }}>
          <SidebarLayout isExpanded={isExpanded} setIsExpanded={setIsExpanded} />

          {/* ✅ Subscription Details Container */}
          <div className="card bg-light text-dark shadow-sm mb-4">
            <div className="card-header text-white">
              <h4 className="mb-0">Your Subscription Details</h4>
            </div>
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Plan:</div>
                <div className="col-sm-8">Subscription</div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Type:</div>
                <div className="col-sm-8">
                  {
                    subscriptionDetails.plan_type == '0'
                      ? 'Free'
                      : subscriptionDetails.plan_type == '1'
                        ? 'Monthly'
                        : subscriptionDetails.plan_type == '2'
                          ? 'Yearly'
                          : 'Custom'
                  }

                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Start Date:</div>
                <div className="col-sm-8">{subscriptionDetails.start_date}</div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">End Date:</div>
                <div className="col-sm-8">{subscriptionDetails.end_date}</div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Status:</div>
                <div className="col-sm-8">{subscriptionDetails.status}</div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Last Payment:</div>
                <div className="col-sm-8">
                  {subscriptionDetails.last_payment_amount
                    ? `$${subscriptionDetails.last_payment_amount} on ${subscriptionDetails.billing_cycle_anchor}`
                    : 'No payment information available'}
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Renewal:</div>
                <div className="col-sm-8">
                  {subscriptionDetails.collection_method === 'charge_automatically' ? 'Auto-renew enabled' : 'Manual renewal required'}
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Customer ID:</div>
                <div className="col-sm-8">{subscriptionDetails.customer_id}</div>
              </div>

              <div className="row mb-3">
                <div className="col-sm-4 font-weight-bold">Search Usage:</div>
                <div className="col-sm-8">{subscriptionDetails.usages ?? 0} of {subscriptionDetails.allowed_tot ?? 20} searches used this month</div>
              </div>

              <hr />

              {
                subscriptionDetails.plan_type != '3' &&
                < div className="row mb-3">
                  <div className="col-sm-4 font-weight-bold">Unlimited Searches:</div>
                  <div className="col-sm-8">
                    <ul className="list-unstyled">
                      <li>Access to premium content</li>
                      <li>Search a wide range of player profiles</li>
                      <li>Priority support</li>
                    </ul>
                    {/* Add the contact support message here */}
                    <p>If you want unlimited searches, <a href="mailto:support@goldcleats.com">Contact Support</a>.</p>
                  </div>
                </div>
              }

            </div>
          </div>
        </div >
      ) : (
        <div className={`container pricing-card text-center py-5 ${isExpanded ? "expanded-search-mobile expanded-pricing" : ""}`} style={{ color: '#EEEEF0' }}>
          {userId && <SidebarLayout isExpanded={isExpanded} setIsExpanded={setIsExpanded} />}
          {/* ✅ Pricing Plans Container */}
          <div className="mb-3 pricing-header">Flexible Pricing for Everyone</div>
          <p className="mb-5 pricing-sub-header">Unlock Your Creative Potential with Our Tailored Plans</p>

          <div className="row justify-content-center">
            {/* Free Plan */}
            <div className="col-md-3">
              <div className="card bg-light text-dark">
                <div className="card-body">
                  <div className="card-title">Free</div>
                  <div className="card-price">
                    $0/<span>month</span>
                  </div>
                  <ul className="list-unstyled mt-3 pricing-list price-free">
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Limited access to AI tools for searching and discovering soccer players.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Search a selection of player profiles suited for general exploration.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Basic email support for inquiries and assistance.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Perfect for individuals exploring soccer talent casually.</span>
                    </li>
                  </ul>
                </div>
                <div class="card-footer">
                  <Link
                    to="//goldcleatspro.page.link/H3Ed"
                    className="btn text-white btn-login btn-outline-primary w-100"
                  >
                    Get Started for Free
                  </Link>
                </div>

              </div>
            </div>

            {/* Monthly Plan */}
            <div className="col-md-3">
              <div className="card bg-dark text-white">
                <div className="card-body">
                  <div className="card-title">Monthly</div>
                  <div className="card-price">
                    $10/<span>month</span>
                  </div>
                  <ul className="list-unstyled mt-3 pricing-list price-100">
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Access to advanced AI tools for searching and discovering soccer players.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Search a wide range of player profiles, tailored to scouts and recruiters.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Email support to assist with your player discovery needs.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Affordable pricing designed for soccer enthusiasts and professionals.</span>
                    </li>
                  </ul>
                </div>
                <div class="card-footer">
                  <Link onClick={() => handleSubscribedBtnClick(1, URL_MONTHLY)}
                    to={user ? URL_MONTHLY : '/login'}
                    className="btn text-white btn-login btn-primary w-100"
                  >
                    Get Started
                  </Link>
                </div>

              </div>
            </div>

            {/* Annual Plan */}
            <div className="col-md-3">
              <div className="card bg-dark text-white">
                <div className="card-body">
                  <div className="card-title">Annually</div>
                  <div className="card-price">
                    $100/<span>Year</span>
                  </div>
                  <span className="badge bg-primary">Save $20</span>
                  <ul className="list-unstyled mt-3 pricing-list price-1000">
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Access to advanced AI tools for searching and discovering soccer players throughout the year.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Enjoy advanced search across a diverse range of player profiles for a full year.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Priority email support to assist with your player discovery and scouting needs.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Cost-effective annual pricing designed for soccer enthusiasts and professionals.</span>
                    </li>
                  </ul>
                </div>
                <div class="card-footer">

                  <Link onClick={() => handleSubscribedBtnClick(2, URL_YEARLY)}
                    to={user ? URL_YEARLY : '/login'}
                    className="btn text-white btn-login btn-primary w-100"
                  >
                    Get Started
                  </Link>
                </div>

              </div>
            </div>


            {/* Custom Plan */}
            <div className="col-md-3">
              <div className="card bg-dark text-white">
                <div className="card-body">
                  <div className="card-title">Custom</div>
                  <div className="card-price">Let’s Talk!</div>
                  <ul className="list-unstyled mt-3 pricing-list">
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Tailored access to AI-powered tools for discovering soccer players, customized to your unique needs.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Flexible search limits and features, designed to suit your organization's scale and requirements.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Dedicated support to assist with personalized solutions and player scouting strategies.</span>
                    </li>
                    <li className="d-flex align-items-start mb-2">
                      <img width={24} src={tick_icon} loading="lazy" alt="Tick Icon" className="me-2" />
                      <span>Custom pricing options to meet the specific demands of your team or business.</span>
                    </li>
                  </ul>
                </div>
                <div class="card-footer">

                  <Link onClick={() => handleSubscribedBtnClick(3, '')}
                    to="/contact-us"
                    className="btn text-white btn-login btn-primary w-100"
                  >
                    Book a call
                  </Link>

                  {/* <button className="btn text-white btn-login btn-primary w-100">Book a call</button> */}
                </div>
              </div>
            </div>



          </div>
        </div>
      )}
    </>
  );

};

export default PricingPlans;
